export enum LanguageCodes {
  English = 'en',
  Lithuanian = 'lt',
  Latvian = 'lv',
  Estonian = 'ee',
}
